import React, {Component} from 'react';
import MUIDataTable from 'mui-datatables';
import Services from '../../services/service';
import Pdf from 'react-to-pdf';

const ref = React.createRef();

const tableOptions = {
  filterType: 'dropdown',
  responsive: 'scrolldown',
  selectableRows: 'none',
  search: false,
  filter: false,
  download: false,
  print: false,
  viewColumns: false,
  pagination: false
};

class SummaryAttendanceDetail extends Component {

  constructor(props){
    super(props);
    this.state = {
      modalAdd: false,
      detailAbsensi: [],
      summary: [],
      startTimeImage: '',
      endTimeImage: ''
    };
  }

  componentDidMount() {
    {this.getAbsensiDetail()}
  }

  getAbsensiDetail = () => {
    const {_id} = this.props.location.state.dataAbsensi;
    Services.getAbsensiDetail({id: _id})
      .then(res => {
        this.setState({
          detailAbsensi: res,
          summary: res.summary,
          startTimeImage: res.detail.startTimeImage,
          endTimeImage: res.detail.endTimeImage
        });
      })
      .catch(err => console.log(err))
  };

  _renderBreadcrumbAbsensi = () => (
    <div style={{marginBottom: 10}}>
      <h1 className="page-header">Absensi Tanggal {this.props.location.state.detailDate} </h1>
    </div>
  );

  _renderBreadcrumbMasuk = () => (
    <div style={{marginBottom: 10}}>
      <h1 className="page-header">Masuk </h1>
    </div>
  );

  _renderBreadcrumbKeluar = () => (
    <div style={{marginBottom: 10, textAlign: 'right'}}>
      <h1 className="page-header">Pulang </h1>
    </div>
  );

  _renderStartTimeSelfie = () => (
    <div style={{flex: 1, width: '100%', height: '100%'}}>
      <img 
        src={`data:image/jpeg;base64,${this.state.startTimeImage}`} 
        style={{width: '100%', height: '100%'}}
        alt="Start Time Image"
      />
    </div>
  );

  _renderEndTimeSelfie = () => (
    <div style={{flex: 1}}>
      <img 
        src={`data:image/jpeg;base64,${this.state.endTimeImage}`}
        style={{width: '100%', height: '100%'}}
        alt="End Time Image"
      />
    </div>
  );

  renderDataAbsensi = () => {
    const { detailAbsensi } = this.state;
    let dataAbsensi = [];
    dataAbsensi.push(detailAbsensi.detail);
    const columns = [
      {
        name: "nip",
        label: "NIP",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "user",
        label: "User",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "position",
        label: "Jabatan",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "phone",
        label: "No Handphone",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "gender",
        label: "Gender",
        options: {
          filter: true,
          sort: true,
        }
      }
    ];

    return (
      <MUIDataTable
        data={dataAbsensi}
        columns={columns}
        options={tableOptions}
      />
    )
  };

  _renderdataMasuk = () => {
    const { detailAbsensi } = this.state;
    let dataAbsensi = [];
    dataAbsensi.push(detailAbsensi.detail)
    const columns = [
      {
        name: "startTime",
        label: "Jam",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "name",
        label: "Lokasi",
        options: {
          filter: true,
          sort: true,
        }
      }
    ];

    return (
      <div style={{flex: 1}}>
        <MUIDataTable
          data={dataAbsensi}
          columns={columns}
          options={tableOptions}
        />
      </div>
    )
  };

  _renderdataKeluar = () => {
    const { detailAbsensi } = this.state;
    let dataAbsensi = [];
    dataAbsensi.push(detailAbsensi.detail)
    const columns = [
      {
        name: "endTime",
        label: "Jam",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "name",
        label: "Lokasi",
        options: {
          filter: true,
          sort: true,
        }
      }
    ];

    return (
      <div style={{flex: 1}}>
        <MUIDataTable
          data={dataAbsensi}
          columns={columns}
          options={tableOptions}
        />
      </div>
    )
  };

  _renderStatus = () => {
    const { detailAbsensi } = this.state;
    let dataAbsensi = [];
    dataAbsensi.push(detailAbsensi.detail)
    const columns = [
      {
        name: "status",
        label: "Status",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "countTotalTime",
        label: "Total Jam Kerja",
        options: {
          filter: true,
          sort: true,
          customBodyRender: value => value ? value + ' jam' : ''
        }
      }
    ];

    return (
      <MUIDataTable
        data={dataAbsensi}
        columns={columns}
        options={tableOptions}
      />
    )
  };

  renderTableAbsensi = () => (
    <div>
      {this._renderBreadcrumbAbsensi()}
      <div>
        {this.renderDataAbsensi()}
      </div>
    </div>
  );

  renderTableMasuk = () => (
    <div>
      <div style={{marginTop: 30}}>
        {this._renderBreadcrumbMasuk()}
      </div>
      <div style={{display: 'flex', flexDirection: 'horizontal'}}>
        {this._renderStartTimeSelfie()}
        {this._renderdataMasuk()}
      </div>
    </div>
  );

  renderTableKeluar = () => (
    <div>
      <div style={{marginTop: 30}}>
        {this._renderBreadcrumbKeluar()}
      </div>
      <div style={{display: 'flex', flexDirection: 'horizontal'}}>
        {this._renderEndTimeSelfie()}
        {this._renderdataKeluar()}
      </div>
    </div>
  );

  renderPrintButton = () => (
    <Pdf targetRef={ref} filename="Attendance Summary.pdf" x={5} y={5} scale={0.55}>
      {({ toPdf }) => 
        <button className="btn btn-success" onClick={toPdf}> Print Attendance Summary </button>
      }
    </Pdf>
  )

  render() {
    return (
      <div>
        <div ref={ref}>
          {this.renderTableAbsensi()}
          {this.renderTableMasuk()}
          <hr />
          {this.renderTableKeluar()}
          <hr />
          {this._renderStatus()}
        </div>
        <div style={{ textAlign: 'center', marginTop: '30px' }}>
          {this.renderPrintButton()}
        </div>
      </div>
    )
  }
}

export default SummaryAttendanceDetail;
